exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#forSpinner[data-v-dfbfcf00]{\n  min-height: 300px;\n}\n#backToList[data-v-dfbfcf00]{\n    cursor: pointer;\n    color: #666;\n}\n#backToList[data-v-dfbfcf00]:hover{\n    color: #888;\n}\n", "", {"version":3,"sources":["/codebuild/output/src663559002/src/slink-frontend/src/pages/OrderDetails.vue"],"names":[],"mappings":";AACA;EACE,kBAAkB;CACnB;AACD;IACI,gBAAgB;IAChB,YAAY;CACf;AACD;IACI,YAAY;CACf","file":"OrderDetails.vue","sourcesContent":["\n#forSpinner[data-v-dfbfcf00]{\n  min-height: 300px;\n}\n#backToList[data-v-dfbfcf00]{\n    cursor: pointer;\n    color: #666;\n}\n#backToList[data-v-dfbfcf00]:hover{\n    color: #888;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-dfbfcf00","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/OrderDetails.vue
// module id = n+Gc
// module chunks = 1